import React from 'react';
import PdfPage from './PdfPage';

function PhotoTile({ url, label, extraClass }) {
  return (
    <div
      className={`tile tile--photo ${extraClass || ''}`}
      style={url ? {
        backgroundImage: `url(${url})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      } : undefined}
    >
      {label && <span className="cap">{label}</span>}
    </div>
  );
}

// 레이아웃별 페이지당 사진 수
export const GALLERY_PER_PAGE = { A: 1, B: 3, D: 6 };

/**
 * 단일 갤러리 페이지를 렌더링.
 * photos: 해당 페이지에 보여줄 사진 배열 (최대 perPage장)
 * startIndex: 전체 사진 중 첫 번째 사진의 인덱스 (캡션 번호용)
 */
function PdfGallery({ data, officeName, dateLabel, startIndex = 0 }) {
  const { layout, photos } = data;
  if (!photos || photos.length === 0) return null;

  const layoutClass = layout === 'A' ? 'p03--a' : layout === 'D' ? 'p03--d' : 'p03--b';
  const label = (i) => String(startIndex + i + 1).padStart(2, '0');

  let body;
  if (layout === 'A') {
    body = <PhotoTile url={photos[0]} label={label(0)} />;
  } else if (layout === 'D') {
    body = photos.map((url, i) => (
      <PhotoTile key={i} url={url} label={label(i)} />
    ));
  } else {
    // Layout B: 히어로(왼쪽, 2행) + 우측 최대 2장
    body = (
      <>
        <PhotoTile url={photos[0]} label={label(0)} extraClass="b-1" />
        {photos[1] && <PhotoTile url={photos[1]} label={label(1)} />}
        {photos[2] && <PhotoTile url={photos[2]} label={label(2)} />}
      </>
    );
  }

  return (
    <PdfPage officeName={officeName} pageLabel="Property Report" dateLabel={dateLabel} className={layoutClass}>
      <div className="p03__band"><span className="p03__chapter">매물 사진</span></div>
      <div className="p03__body">{body}</div>
    </PdfPage>
  );
}

export default PdfGallery;
